import React from "react";
import ProductivityChart from "./components/ProductivityChart";

function App() {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <ProductivityChart />
    </div>
  );
}

export default App;